import { Formik } from 'formik';
import { useState, useRef } from 'react';
import { initValuesTraining, validationSchemaTraining } from './createTrainingValidation';
import Form from "./TrainingConfigForm";
import { useAxios } from "../../../../context/AxiosHookContext";
import { useNotification } from '../../../../context/NotificationContext';
import SuccessModal from '../../../modal/SuccessModal';

const TrainingForm = ({ onClose, valuesToEdit }) => {
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const fileInputRef = useRef(null);

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initValuesTraining
    }

    const { showSnackbar } = useNotification();

    const axios = useAxios();


    const handleSubmit = async (training, { resetForm }) => {
        try {
            await axios.post("/trainings/create", training);
         
            setShowSuccessModal(true);
            resetForm();
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }

        } catch (error) {
            showSnackbar({
                severity: "error",
                title: "Training",
                message: "Ha ocurrido un error al guardar la configuración."
            });
        }
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        if (onClose) onClose();
    };

    return (
        <>
            <Formik
                validationSchema={validationSchemaTraining}
                initialValues={getInitialValues()}
                onSubmit={handleSubmit}
            >
                <Form onClose={() => { onClose() }} fileInputRef={fileInputRef} />
            </Formik>
            
            <SuccessModal 
                open={showSuccessModal} 
                onClose={handleCloseSuccessModal} 
            />
        </>
    )
}

export default TrainingForm